import { useQuery } from '@tanstack/react-query'
import { EntityWithIdAndDescription, SectorComercial, UnidadNegocio } from '../../../../../types'
import { HttpCacheOperacion } from '../../../api/httpCacheOperacion'
import {OperacionLCLSLimiteTipo, OperacionLCLSRelacion, OperacionLCSLSSectorComercial, OperacionLCSLSUnidadNegocio} from "../types/dto";

export const useLCLSLimiteTipos = () => {
    const {
        data: limiteTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCLSLimiteTipo[], Error>({
        queryKey: ['lcls-limite-tipos'],
        queryFn: () => HttpCacheOperacion.getLCLSLimiteTipos()
    })

    return {
        limiteTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCLSClienteSubTipos = (codPais: number | undefined | null) => {
    const {
        data: clienteSubTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['lcls-cliente-sub-tipos', codPais],
        queryFn: () => HttpCacheOperacion.getLCLSClienteSubTipos(codPais!),
        enabled: !!codPais
    })

    return { clienteSubTipos, isLoading, isError, error }
}

export const useLCLSClienteTipos = (codPais: number | undefined | null) => {
    const {
        data: clienteTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<EntityWithIdAndDescription[], Error>({
        queryKey: ['lcls-cliente-tipos', codPais],
        queryFn: () => HttpCacheOperacion.getLCLSClienteTipos(codPais!),
        enabled: !!codPais
    })

    return {
        clienteTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCLSUnidadNegocioTipos = (codPais: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: unidadNegocioTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<UnidadNegocio[], Error>({
        queryKey: ['lcls-unidad-negocio-tipos', codPais],
        queryFn: () => HttpCacheOperacion.getUnidadesNegocioPorPaisYSistema(codPais!, codSistema!),
        enabled: !!codPais && !!codSistema
    })

    return {
        unidadNegocioTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCLSSectorComercialTipos = (codUnidadNegocio: number | undefined | null, codSistema: number | undefined | null) => {
    const {
        data: sectorComercialTipos = [],
        isLoading,
        isError,
        error
    } = useQuery<SectorComercial[], Error>({
        queryKey: ['LCLS-sector-comercial-tipos', codUnidadNegocio],
        queryFn: () => HttpCacheOperacion.getSectoresComercialesPorUnidadNegocio(codUnidadNegocio!, codSistema!),
        enabled: !!codUnidadNegocio && !!codSistema
    })

    return {
        sectorComercialTipos,
        isLoading,
        isError,
        error
    }
}

export const useLCLSRelacionTipos = (codSectorComercial: number | undefined | null) => {
    const {
        data: relaciones = [],
        isLoading,
        isError,
        error
    } = useQuery<OperacionLCLSRelacion[], Error>({
        queryKey: ['LCLS-relaciones', codSectorComercial],
        queryFn: () => HttpCacheOperacion.getLCLSRelacionTipos(codSectorComercial!),
        enabled: !!codSectorComercial
    })

    return {
        relaciones,
        isLoading,
        isError,
        error
    }
}